import { styled } from 'styled-components';
import React, { FC, PropsWithChildren } from 'react';
import { Box } from '@idk-web/core-ui';
import Header from '@/components/form/header/Header';
import Footer from '@/components/form/footer/Footer';

const Container = styled(Box).attrs({
  direction: 'vertical',
})`
  min-height: 100vh;
`;

const Main = styled.main`
  position: relative;
  display: flex;
  flex-grow: 1;
  background-color: ${({ theme }) => theme.palette.grayscale.light5};
`;

export type LayoutProps = PropsWithChildren<{
  logo?: string;
  showFooter?: boolean;
}>;

const Layout: FC<LayoutProps> = ({ logo, showFooter, children }) => {
  return (
    <Container>
      <Header logo={logo} />
      <Main>{children}</Main>
      <Footer showContent={showFooter ?? false} />
    </Container>
  );
};

export default Layout;
